<template >
  <li :class="[
    { 'cursor-not-allowed': link.disabled },
    { 'cursor-wait-ov' : isGeneralLoading}
    ]" >
  <el-tooltip 
    v-model="visibleTooltip" 
    :manual="true" 
    placement="right" 
    :disabled="!link.info"
    >
    <div slot="content" :class="isLower1024 ? 'max-w-[18rem]' : ''" 
      @mouseenter="setVisible(true)"
      @mouseleave="setVisible(false)">                 
      <div class="max-w-sm max-h-500p overflow-auto">                  
        <header><p><b>{{ link.name }}</b></p></header>
        <p>{{ link.info }}</p>
      </div>
    </div>
    <span   
      :tabindex="(link.disabled || isGeneralLoading) ? -1 : 0"
      @click.prevent="proxyActivate"
      @keydown.enter.prevent="proxyActivate"
      @keydown.space.prevent="proxyActivate"
      @keydown.esc="setVisible(false)"
      @mouseenter="setVisible(true)"
      @mouseleave="setVisible(false)"
      @focusin="setVisible(true)"
      @focusout="setVisible(false)"
      @blur="setVisible(false)">
      <router-link
        ref="navLink"
        :to="{ name: link.path, params: link.params }"
        :class="[
          { 'router-link-disabled': (link.disabled || isGeneralLoading) },
        ]"
        class="child flex items-center pl-18 pr-4 hover:bg-primary-100 dark:hover:bg-darkblue-600 active:bg-primary-200 group animate-hover"
        :tabindex="-1"
        :aria-current="$route.name === link.path ? 'page' : null"
        :aria-label="link.name"
        :aria-describedby="[
          link.info ? 'desc-link-' + link.path : '',
          link.counter ? 'counter-link-' + link.path : ''
        ].filter(Boolean).join(' ')"
      >
        <span class="span-nav-link-container w-full overflow-hidden pl-2 flex h-full border-l-2 border-solid items-center cover-subnav"
          >
          <span class="link-name w-full pt-[0.35rem] pb-[0.35rem] group-hover:text-primary-900 group-hover:font-bold dark:group-hover:text-primary dark:text-darkblue-200">
            <div v-if="link.info" class="flex items-center" tabindex="-1">
              <span :class="{ 'color-link-disabled': link.warning === 2 }">
                {{ link.name }} 
              </span>
              <span v-if="link.warning === 1" class="k-icon k-i-warning color-warning ml-1 pr-1"/>
            </div>
            <div v-if="!link.info" class="flex items-center">
              <span :class="{ 'color-link-disabled': link.warning === 2 }">
                {{ link.name }} 
              </span>
              <span v-if="link.warning === 1" class="k-icon k-i-warning color-warning ml-1 pr-1"/>
            </div>                                                  
            <!-- <span v-if="link.info" :id="'desc-link-' + link.path" class="sr-only">{{ link.info }}</span> -->
          </span>
          <span v-if="link.counter" :id="'counter-link-' + link.path" class="sr-only">{{ link.counter }}</span>
          <span v-if="link.counter" class="h-6 font-medium shadow flex-shrink-0 px-2 bg-white text-xs text-secondary flex items-center justify-center rounded-full" aria-hidden="true">
              {{ link.counter }}
          </span>
        </span>
      </router-link>
    </span>
  </el-tooltip>   
  </li>
</template>

<script>
import { bus } from '@/main'

export default {
  name: 'aside-nav-item-link',
  props: {
    link: {
      type: [Object],
      required: true
    },
    role: {
      type: String,
      default: null
    }

  },
  data: function () {
    return {
      visibleTooltip: false,
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isLower1024 () {
      return this.$store.getters['app/getIsLower1024']
    }
  },
  watch: {
    visibleTooltip (visible) {
      if (visible) {
        document.addEventListener('keydown', this.onKeydown)
        bus.$emit('asideTooltipVisibility', true)
      } else {
        document.removeEventListener('keydown', this.onKeydown)
        bus.$emit('asideTooltipVisibility', false)
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onKeydown)
    if (this.visibleTooltip) bus.$emit('asideTooltipVisibility', false)
  },
  methods: {
    setVisible (val) {
      this.visibleTooltip = val

      if (this.link?.info && val) {
        this.doFeedback(this.link?.info, 'info', 3000, true)
      }
    },
    proxyActivate () {
      if (this.link.disabled || this.isGeneralLoading) return

      // Navegar programáticamente evita que NVDA intente "activar" un <a> tabindex=-1
      const to = { name: this.link.path, params: this.link.params }
      this.$router.push(to).catch(() => {})
    },
    onKeydown (event) {
      if (event.key === 'Escape') {
        this.visibleTooltip = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
a.parent {
  @apply pl-4 pr-5;
}
[data-type='main'] {
  a.parent {
    @apply pl-3 pr-1;
  }
}
a.child {
  @apply pl-14;
}
[data-type='main'] {
  a.child {
    @apply pl-11;
  }
}

.animate-hover {
  @apply transition-colors duration-300;
}
.animate-all {
  @apply transition-all duration-300;
}
.cover-subnav {
  @apply border-secondary-100;
}
.span-nav-link-container{
  @apply border-secondary-200;
}
.link-icon {
  @apply text-secondary-500 dark:text-darkblue-400;
}
.link-name {
    @apply text-secondary-800 dark:text-darkblue-200 font-medium;
  }
.color-link-disabled{
  @apply text-secondary-600;
}
.dark .color-link-disabled{
  @apply text-secondary-300;
}
.router-link-active {
  .link-icon {
    @apply text-secondary dark:text-darkblue-200;
  }
  .link-name {
    @apply text-secondary-800 dark:text-darkblue-100 font-bold;
  }
  .color-link-disabled{
    @apply text-secondary-800;
  }
  .cover-subnav {
    @apply border-primary;
  }
  .span-nav-link-container{
    @apply border-primary;
    border-left-width: 4px!important;
  }
}
.dark .router-link-active .color-link-disabled {
  color: var(--darkblue-200);
}
.rotate-180 {
  transform: rotate(-180deg);
}
.list-links-enter-active,
.list-links-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.list-links-enter,
.list-links-leave-to {
  height: 0 !important;
}
</style>
